import type { Maybe } from '@takeshape/util';
import keyBy from 'lodash/keyBy';
import type { ServiceProvider } from '../types';
import anthropic from './anthropic-provider';
import arize from './arize-provider';
import auth0 from './auth0-provider';
import awsLambda from './aws-lambda-provider';
import azureOpenai from './azure-openai-provider';
import bigcommerce from './bigcommerce-provider';
import commercelayer from './commercelayer-provider';
import contentful from './contentful-provider';
import elasticpath from './elasticpath-provider';
import fauna from './fauna-provider';
import grapqhl from './generic-graphql-provider';
import rest from './generic-rest-provider';
import googleVertex from './google-vertex-provider';
import gorgias from './gorgias-provider';
import groq from './groq-provider';
import hygraph from './hygraph-provider';
import judgeMe from './judge-me-provider';
import klaviyo from './klaviyo-provider';
import loyaltylion from './loyaltylion-provider';
import mailchimp from './mailchimp-provider';
import netlify from './netlify-provider';
import notion from './notion-provider';
import oidc from './oidc-provider';
import olyslager from './olyslager-provider';
import openAi from './openai-provider';
import openapi from './openapi-provider';
import petfinder from './petfinder-provider';
import postscript from './postscript-provider';
import recharge from './recharge-provider';
import reviewsIo from './reviews-io-provider';
import riseAiCredit from './rise-ai-credit-provider';
import riseAiGifting from './rise-ai-gifting-provider';
import salsify from './salsify-provider';
import sanity from './sanity-provider';
import shipEngine from './ship-engine-provider';
import shopify from './shopify-provider';
import shopifyStorefront from './shopify-storefront-provider';
import stripe from './stripe-provider';
import submarine from './submarine-provider';
import syndigo from './syndigo-provider';
import unstructured from './unstructured-provider';
import vercel from './vercel-provider';
import voyageai from './voyageai-provider';
import wordpress from './wordpress-provider';
import yelp from './yelp-provider';
import yotpoLoyalty from './yotpo-loyalty-provider';
import yotpoUgc from './yotpo-ugc-provider';

const providers: Record<string, ServiceProvider> = keyBy(
  [
    grapqhl,
    rest,
    openapi,
    bigcommerce,
    netlify,
    shopify,
    shopifyStorefront,
    vercel,
    auth0,
    mailchimp,
    klaviyo,
    commercelayer,
    petfinder,
    stripe,
    fauna,
    contentful,
    hygraph,
    awsLambda,
    notion,
    yelp,
    reviewsIo,
    judgeMe,
    shipEngine,
    oidc,
    elasticpath,
    loyaltylion,
    shopify,
    salsify,
    sanity,
    gorgias,
    yotpoUgc,
    yotpoLoyalty,
    postscript,
    riseAiCredit,
    riseAiGifting,
    recharge,
    wordpress,
    openAi,
    voyageai,
    anthropic,
    submarine,
    arize,
    unstructured,
    azureOpenai,
    googleVertex,
    syndigo,
    olyslager,
    groq
  ],
  'name'
);

export function findProvider(providerName: string): Maybe<ServiceProvider> {
  return providers[providerName];
}

export default providers;
